export const V2_BUNDLE_PATH = '/v2/build/';
export const EXPLICIT_REPORT_PARAM = 'dmV2Reported';

export function shouldCreateNotifier(environment: string | undefined, isV2LayoutPage: boolean): boolean {
  return environment === 'production' && isV2LayoutPage;
}

export function isIgnoredUserAgent(userAgent: string | undefined, ignored: readonly string[]): boolean {
  if (!userAgent) {
    return false;
  }

  const lowered = userAgent.toLowerCase();

  return ignored.some((fragment) => fragment !== '' && lowered.includes(fragment.toLowerCase()));
}

export function isExplicitReport(notice: { params?: Record<string, unknown> }): boolean {
  return notice.params?.[EXPLICIT_REPORT_PARAM] === true;
}

/**
 * Origin is judged from the value the page threw, never from a notice's backtrace: for a value
 * without a parseable stack Airbrake fills the backtrace with its own frames, which live in our
 * bundle and would let GTM, the consent manager, ads and extensions through.
 */
export function stackIsFromV2Bundle(stack: unknown): boolean {
  return typeof stack === 'string' && stack.includes(V2_BUNDLE_PATH);
}

export function errorEventIsFromV2Bundle(event: { filename?: string; error?: unknown }): boolean {
  if (typeof event.filename === 'string' && event.filename.includes(V2_BUNDLE_PATH)) {
    return true;
  }

  return (
    typeof event.error === 'object' &&
    event.error !== null &&
    stackIsFromV2Bundle((event.error as { stack?: unknown }).stack)
  );
}

export function rejectionIsFromV2Bundle(reason: unknown): boolean {
  return reason instanceof Error && stackIsFromV2Bundle(reason.stack);
}
